import React from "react";
import { NextPage } from "next";
import { CommonData } from "../../types/CommonData";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { getCommonData } from "../../helpers/common-data";
import { InteriorDesigner } from "../../components/InteriorDesigner";
import { css } from "styled-components";
import { SEOTags } from "../../components/SEOTags";
import { getFrontendUrl } from "../../helpers/utils";
import { getRichSnippet } from "../../helpers/rich-snippets/static";
import PreviewImage from "../../static/images/preview-curate-your-space.png";

export const PageInteriorDesigner: NextPage<{
  commonData: CommonData;
}> = () => {
  const data = {
    title: "Curate Your Space",
    keywords: "Curator, designer, web tools",
    description:
      "Create a custom scale rendering of your favorite Drew Doggett prints in your space while the pricing and framing adjusts in real time",
    url: getFrontendUrl(`/curate-your-space`),
    about:
      "A custom tool to create a scale mockup of a limited edition Drew Doggett Photography print in an image of your choosing",
    image: PreviewImage,
  };

  return (
    <>
      <SEOTags
        title={data.title}
        description={data.description}
        keywords={data.keywords}
        url={data.url}
        image={data.image}
        richSnippets={getRichSnippet({
          name: data.title,
          slug: "curate-your-space",
          keywords: data.keywords,
          description: data.description,
          about: data.about,
        })}
      />
      <Header announcements={[]} />
      <div
        css={css`
          height: calc(100vh - 70px);
        `}
      >
        <InteriorDesigner />
      </div>
      <Footer />
    </>
  );
};

PageInteriorDesigner.getInitialProps = async ({ req }) => {
  const commonData = await getCommonData(req);

  return {
    commonData: commonData,
  };
};

export default PageInteriorDesigner;
